import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import type {EventAttributes, EventLink} from '~/common/event/types';

const INITIAL_STATE: EventAttributes = {
  links: [],
};

const eventAttributesSlice = createSlice({
  name: 'eventAttributes',
  initialState: INITIAL_STATE,
  reducers: {
    setEventAttributes: (state, action: PayloadAction<EventAttributes>) => ({
      ...state,
      ...action.payload,
    }),
    updateEventLinks: (state, action: PayloadAction<EventLink[]>) => ({
      ...state,
      links: action.payload,
    }),
  },
  selectors: {
    selectEventAttributes: (state) => state,
    selectEventLinks: (state) => state.links,
    selectEventHasAdditionalLinks: (state) => state.links.length > 0,
  },
});

export const {setEventAttributes, updateEventLinks} = eventAttributesSlice.actions;
export const {selectEventAttributes, selectEventLinks, selectEventHasAdditionalLinks} =
  eventAttributesSlice.selectors;
export const eventAttributesReducer = eventAttributesSlice.reducer;
